export const BUNDLE = {
  minQty: 3,
  discountPerBlaster: 10,
  giftQty: 6,
  giftName: "Gelvaro Bundel Pack",
  giftDescription: "30.000 extra gel orbs, 6 veiligheidsbrillen en tactische pouch",
};

export const computeBundle = (items) => {
  const qty = items.reduce((sum, i) => sum + i.qty, 0);
  const active = qty >= BUNDLE.minQty;
  const gift = qty >= BUNDLE.giftQty;
  const discount = active ? qty * BUNDLE.discountPerBlaster : 0;
  let nudge = null;
  if (qty > 0 && !active) {
    const left = BUNDLE.minQty - qty;
    nudge = `Nog ${left} blaster${left > 1 ? "s" : ""} en je krijgt €${BUNDLE.discountPerBlaster} korting per blaster`;
  } else if (active && !gift) {
    const left = BUNDLE.giftQty - qty;
    nudge = `Nog ${left} blaster${left > 1 ? "s" : ""} tot je gratis ${BUNDLE.giftName}`;
  }
  return { qty, active, gift, discount, nudge };
};
